<!-- <app-loading [isLoading]="isLoading"></app-loading> -->
<div class="overlay" [class.visible]="isOpen"></div>
<div class="slider-wrapper" [class.open]="isOpen">
    <div class="content">
        <div class="left-side">
            <!-- Form 1 (step 1) -->
            <div *ngIf="step === 1">
                <form [formGroup]="devoteeDetailsForm" (ngSubmit)="nextStep()">
                    <div class="title-section">
                        <span>Create New Nibedon</span>
                        <div class="cross" (click)="onClose()">
                            <img src="../../../../assets/cross-white.svg">
                        </div>
                    </div>

                    <div class="form">
                        <div>
                            <label for="" class="input-label">First Name*</label>
                            <input type="text" #step1Input placeholder="First Name*" formControlName="firstName"
                                (keydown)="allowedLetters($event)" (paste)="validatePaste($event, 'firstName')">
                            <div class="error" *ngIf="devoteeDetailsForm.get('firstName')?.invalid 
                               && (devoteeDetailsForm.get('firstName')?.touched 
                               || devoteeDetailsForm.get('firstName')?.dirty)">
                                This field is required
                            </div>

                            <div class="error" *ngIf="pasteErrors.firstName">
                                Special characters are not allowed
                            </div>
                        </div>

                        <div>
                            <label for="" class="input-label">Middle Name</label>
                            <input type="text" placeholder="Middle Name" formControlName="middleName"
                                (keydown)="allowedLetters($event)" (paste)="validatePaste($event, 'middleName')">
                            <!-- <div class="error" *ngIf="devoteeDetailsForm.get('middleName')?.invalid 
                               && (devoteeDetailsForm.get('middleName')?.touched 
                               || devoteeDetailsForm.get('middleName')?.dirty)">
                                This field is required
                            </div> -->
                            <div class="error" *ngIf="pasteErrors.middleName">
                                Special characters are not allowed
                            </div>
                        </div>

                        <div>
                            <label for="" class="input-label">Last Name*</label>
                            <input type="text" placeholder="Last Name*" formControlName="lastName"
                                (keydown)="allowedLetters($event)" (paste)="validatePaste($event, 'lastName')">
                            <div class="error" *ngIf="devoteeDetailsForm.get('lastName')?.invalid 
                               && (devoteeDetailsForm.get('lastName')?.touched 
                               || devoteeDetailsForm.get('lastName')?.dirty)">
                                This field is required
                            </div>
                            <div class="error" *ngIf="pasteErrors.lastName">
                                Special characters are not allowed
                            </div>
                        </div>

                        <div>
                            <label for="" class="input-label">Phone Number*</label>
                            <input type="tel" placeholder="Phone Number*" maxlength="10" formControlName="phoneNumber"
                                (keydown)="allowedDigits($event)">
                            <div class="error" *ngIf="devoteeDetailsForm.get('phoneNumber')?.invalid 
                               && (devoteeDetailsForm.get('phoneNumber')?.touched 
                               || devoteeDetailsForm.get('phoneNumber')?.dirty)">
                                This field is required
                            </div>
                        </div>

                        <div>
                            <label for="" class="input-label">Alternative Phone Number</label>
                            <input type="tel" placeholder="Alternative Phone Number" maxlength="10"
                                formControlName="alternatePhoneNumber" (keydown)="allowedDigits($event)">
                        </div>

                        <div>
                            <label for="" class="input-label">Family Code</label>
                            <input type="tel" placeholder="Family Code" maxlength="12" formControlName="familyCode"
                                (keydown)="allowedDigits($event)">
                            <div class="error" *ngIf="devoteeDetailsForm.get('familyCode')?.invalid 
                               && (devoteeDetailsForm.get('familyCode')?.touched 
                               || devoteeDetailsForm.get('familyCode')?.dirty)">
                                This field is required
                            </div>
                        </div>

                        <div class="smallputs">
                            <div style="flex: 1;">
                                <label for="" class="input-label">Age*</label>
                                <input type="text" placeholder="Age*" maxlength="3" formControlName="age"
                                    (keydown)="allowedDigits($event)">
                                <div class="error" *ngIf="devoteeDetailsForm.get('age')?.invalid 
                                      && (devoteeDetailsForm.get('age')?.touched 
                                      || devoteeDetailsForm.get('age')?.dirty)">
                                    This field is required
                                </div>
                            </div>

                            <div style="flex: 1;">
                                <label for="" class="input-label">Gender*</label>
                                <mat-select formControlName="gender" placeholder="Gender*">
                                    <mat-option value="male">Male</mat-option>
                                    <mat-option value="female">Female</mat-option>
                                    <mat-option value="others">Others</mat-option>
                                </mat-select>
                                <div class="error" *ngIf="devoteeDetailsForm.get('gender')?.invalid 
                                      && (devoteeDetailsForm.get('gender')?.touched 
                                      || devoteeDetailsForm.get('gender')?.dirty)">
                                    This field is required
                                </div>
                            </div>

                        </div>
                        <div class="btn">
                            <button *ngIf="isDraft" class="draft-btn" type="draft" [disabled]="isLoading" (click)="addToDraft()">Add to
                                draft
                                <i *ngIf="isLoading" class="fas fa-spinner fa-spin ms-1"></i>
                            </button>
                            <button class="next-btn" type="submit">Next</button>
                        </div>
                    </div>
                </form>
            </div>

            <div *ngIf="step===2">
                <!-- Form - 2 (step-2) -->
                <form [formGroup]="addressDetailsForm" (ngSubmit)="nextStep()">
                    <div class="title-section">
                        <div class="left-part">
                            <div class="backward" (click)="prevStep()">
                                <img src="../../../../assets/arrow-left.svg" alt="">
                            </div>
                            <span>Address Details</span>
                        </div>
                        <div class="cross" (click)="onClose()">
                            <img src="../../../../assets/cross-white.svg">
                        </div>
                    </div>
                    <div class="form">

                        <div>
                            <label for="" class="input-label">Pincode*</label>
                            <input type="text" #step2Input placeholder="Pincode*" maxlength="6" class="input"
                                formControlName="pincode" (keydown)="allowedDigits($event)">
                        </div>

                        <div class="smallputs">
                            <div>
                                <label for="" class="input-label">State*</label>
                                <input type="text" placeholder="State*" class="input" formControlName="state"
                                    *ngIf="stateArray.length<=1">

                                <mat-select formControlName="state" *ngIf="stateArray.length>1" style="flex: 1;"
                                    placeholder="Select State" (selectionChange)="onSelectingState($event)">
                                    <mat-option *ngFor="let state of stateArray" [value]="state">
                                        {{state}}
                                    </mat-option>
                                </mat-select>
                            </div>
                            <div>
                                <label for="" class="input-label">District*</label>
                                <input type="text" placeholder="District*" class="input" formControlName="district"
                                    *ngIf="districtArray.length<=1">

                                <mat-select formControlName="district" *ngIf="districtArray.length>1" style="flex: 1;"
                                    placeholder="Select District" (selectionChange)="onSelectingDistrict($event)">
                                    <mat-option *ngFor="let district of districtArray" [value]="district">
                                        {{district}}
                                    </mat-option>
                                </mat-select>
                            </div>

                            <div>
                                <label for="" class="input-label">Post Office*</label>
                                <input type="text" placeholder="Post Office*" style="width: 100%;" class="input"
                                    formControlName="po" *ngIf="postOfficeArray.length<=1">

                                <mat-select formControlName="po" *ngIf="postOfficeArray.length>1" style="flex: 1;"
                                    placeholder="Select a PO">
                                    <mat-option *ngFor="let post of postOfficeArray" [value]="post">
                                        {{post}}
                                    </mat-option>
                                </mat-select>
                            </div>
                        </div>

                        <div class="address-adjus">
                            <label for="" class="input-label">Adress*</label>
                            <textarea name="" id="" placeholder="Adress*" formControlName="address"></textarea>
                        </div>
                        <div class="btn">
                            <button *ngIf="isDraft" class="draft-btn" type="draft" [disabled]="isLoading" (click)="addToDraft()">Add to
                                draft
                                 <i *ngIf="isLoading" class="fas fa-spinner fa-spin ms-1"></i>
                            </button>

                            <button class="next-btn" type="submit">Next</button>
                        </div>
                    </div>
                </form>
            </div>

            <div *ngIf="step===3">
                <!-- Form - 3 (step-3) -->
                <form [formGroup]="otherDetailsForm" (ngSubmit)="nextStep()">
                    <div class="title-section">
                        <div class="left-part">
                            <div class="backward" (click)="prevStep()">
                                <img src="../../../../assets/arrow-left.svg" alt="">
                            </div>
                            <span>Other Details</span>
                        </div>
                        <div class="cross" (click)="onClose()">
                            <img src="../../../../assets/cross-white.svg">
                        </div>
                    </div>

                    <div class="form">
                        <input type="text" #step3Input placeholder="Ritwik Name" style="flex: 1;" class="input"
                            formControlName="ritwikName" [matAutocomplete]="fetchRitwikName">

                        <mat-select formControlName="nivedanCategory" name="nivedanCat" style="flex: 1;"
                            placeholder="Select Category*">
                            <mat-option *ngFor="let category of nivedonCategory"
                                [value]="category.categoryCode">{{category.description}}</mat-option>
                        </mat-select>

                        <div class="smallputs">
                            <mat-select placeholder="Initiated" formControlName="initiated" style="flex: 1;">
                                <mat-option value="yes">
                                    Yes
                                </mat-option>
                                <mat-option value="no">
                                    No
                                </mat-option>
                            </mat-select>

                            <!-- <select formControlName="initiated" style="flex: 1;">
                                <option value="">Initated*</option>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </select> -->

                            <mat-select formControlName="swastayini" style="flex: 1;" placeholder="Swastayini">
                                <mat-option value="yes">Yes</mat-option>
                                <mat-option value="no">No</mat-option>
                            </mat-select>


                            <mat-autocomplete #fetchRitwikName="matAutocomplete">
                                <mat-option *ngFor="let ritwik of ritwikList"
                                    (onSelectionChange)="onRitwikDropDown(ritwik)" [value]="ritwik.fullName">
                                    <div>
                                        <span class="option-title">{{ritwik.fullName}}</span>
                                        <p>{{ritwik.district | titlecase}}{{ritwik.district?.length ? ',' : ''}}
                                            {{ritwik.state |
                                            titlecase}}</p>
                                    </div>
                                </mat-option>
                            </mat-autocomplete>

                            <mat-select formControlName="maritalStatus" placeholder="Marital Status*">
                                <mat-option value="yes">Married</mat-option>
                                <mat-option value="no">Not Married</mat-option>
                            </mat-select>
                        </div>
                        <div class="btn">
                            <button *ngIf="isDraft" class="draft-btn" type="draft" [disabled]="isLoading" (click)="addToDraft()">Add to
                                draft
                                 <i *ngIf="isLoading" class="fas fa-spinner fa-spin ms-1"></i>
                            </button>

                            <button class="next-btn" type="submit">Next</button>
                        </div>
                    </div>
                </form>
            </div>

            <div *ngIf="step===4">
                <!-- Form - 4 (step-4) -->
                <form [formGroup]="nibedonDetailsForm">
                    <div class="title-section">
                        <div class="left-part">
                            <div class="backward" (click)="prevStep()">
                                <img src="../../../../assets/arrow-left.svg" alt="">
                            </div>
                            <span>Nibedon Details</span>
                        </div>
                        <div class="cross" (click)="onClose()">
                            <img src="../../../../assets/cross-white.svg">
                        </div>
                    </div>

                    <div class="form">

                        <div>
                            <label for="" class="input-label">Remarks/Comments*</label>
                            <input type="text" #step4Input placeholder="Remarks/Comments*" class="input"
                                formControlName="remarks">
                        </div>

                        <div class="address-adjus">
                            <label for="" class="input-label">Nibedon*</label>
                            <textarea name="" id="" placeholder="Nibedon*" style="height: 225px;"
                                formControlName="nibedon"></textarea>
                        </div>

                        <div class="custom-dropdown">
                            <mat-checkbox formControlName="isUrgent"></mat-checkbox>
                            <div class="urgent-div">
                                <label for="" class="input-label">Mark As Urgent</label>
                                <img src="../../../../assets/urgen-sign.svg" style="width: 20px; height: 20px;" alt="">
                            </div>
                        </div>

                        <div class="btn">
                            <button *ngIf="isDraft" class="draft-btn" type="draft" [disabled]="isLoading" (click)="addToDraft()">Add to
                                draft
                                 <i *ngIf="isLoading" class="fas fa-spinner fa-spin ms-1"></i>
                            </button>

                            <button *ngIf="isDraft" class="next-btn" type="submit" [disabled]="isFinalSubmit" (click)="onSubmit()">
                                Submit
                                 <i *ngIf="isFinalSubmit" class="fas fa-spinner fa-spin ms-1"></i>
                            </button>
                            <button *ngIf="!isDraft" class="next-btn" [disabled]="isSubmitting" (click)="submitDraftNivedan()">
                                Submit Draft
                                 <i *ngIf="isSubmitting" class="fas fa-spinner fa-spin ms-1"></i>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="right-side">
            <span class="stepper">STEP {{step}}/4</span>

            <div class="stepper-container">
                <div class="steppers">
                    <div class="d-flex stepper-gap" [ngClass]="devoteeDetailsForm.valid ? 'cursor-pointer' : ''"
                        (click)="devoteeDetailsForm.valid && navigateToSpecificForm(1)">
                        <div class="d-flex flex-column align-items-center">
                            <img src="/assets/stepper.svg" *ngIf="step == 1" />
                            <img [src]="!showPrimaryStepError ? '/assets/checkbox-circle-fill.svg' : '/assets/stepper-copy.svg'"
                                *ngIf="step != 1" height="19px" width="16px" style="cursor: pointer;" />

                            <div *ngIf="!showPrimaryStepError"
                                [class]="step == 1 ? 'border-dashed':'golden-dashed-line'"></div>
                            <div *ngIf="showPrimaryStepError" [class]="step == 1 ? 'border-dashed':'red-dashed-lines'">
                            </div>

                        </div>
                        <div class="d-flex flex-column">
                            <span [ngClass]="
                              step == 1 ? 'stepper-text' : 'stepper-text-active'">Primary Details</span>
                        </div>
                    </div>
                    <div class="d-flex stepper-gap" [ngClass]="addressDetailsForm.valid ? 'cursor-pointer' : ''"
                        (click)="addressDetailsForm.valid && navigateToSpecificForm(2)">
                        <div class="d-flex flex-column align-items-center">
                            <img src="/assets/stepper-disable.svg" *ngIf="step < 2" />
                            <img *ngIf="step == 2" src="/assets/stepper.svg">
                            <img [src]="!showAddressStepError ? '/assets/checkbox-circle-fill.svg' : '/assets/stepper-copy.svg'"
                                height="19px" width="16px" color="red" *ngIf="step == 3 || step == 4"
                                style="cursor: pointer;" />
                            <div *ngIf="!showAddressStepError">
                                <div class="border-dashed" *ngIf="step < 3"></div>
                                <div class="golden-dashed-line" *ngIf="step == 3 || step == 4"></div>
                            </div>
                            <div *ngIf="showAddressStepError">
                                <div class="border-dashed" *ngIf="step < 3"></div>
                                <div class="red-dashed-lines" *ngIf="step == 3 || step == 4"></div>
                            </div>

                        </div>
                        <div class="d-flex flex-column">
                            <span class="ms-3"
                                [ngClass]="step == 1 ? 'stepper-text-disable' : [step == 2 ? 'stepper-text' : 'stepper-text-active']">Address
                                Details</span>
                        </div>
                    </div>
                    <div class="d-flex stepper-gap" [ngClass]="otherDetailsForm.valid ? 'cursor-pointer' : ''"
                        (click)="otherDetailsForm.valid && navigateToSpecificForm(3)">
                        <div class="d-flex flex-column align-items-center">
                            <img src="/assets/stepper-disable.svg" *ngIf="step < 3" />
                            <img *ngIf="step == 3" src="/assets/stepper.svg" alt="">
                            <img [src]="!showNibedonStepError ? '/assets/checkbox-circle-fill.svg' : '/assets/stepper-copy.svg'"
                                height="19px" width="16px" *ngIf="step == 4" style="cursor: pointer;" />
                            <div *ngIf="!showNibedonStepError">
                                <div class="border-dashed" *ngIf="step < 4"></div>
                                <div class="golden-dashed-line" *ngIf="step == 4"></div>
                            </div>
                            <div *ngIf="showNibedonStepError">
                                <div class="border-dashed" *ngIf="step < 4"></div>
                                <div class="red-dashed-lines" *ngIf="step == 4"></div>
                            </div>

                        </div>
                        <div class="d-flex flex-column">
                            <span class="ms-3"
                                [ngClass]="step < 3? 'stepper-text-disable': [step == 3 ? 'stepper-text' : 'stepper-text-active'] ">Other
                                Details</span>
                        </div>
                    </div>
                    <div class="d-flex" [ngClass]="(step == 4 && nibedonDetailsForm.valid) ? 'cursor-pointer' : ''"
                        (click)="nibedonDetailsForm.valid && navigateToSpecificForm(4)">
                        <div class="d-flex align-items-center">
                            <img src="/assets/stepper-disable.svg" *ngIf="step < 4" />
                            <img src="/assets/stepper.svg" *ngIf="step == 4 && !nibedonDetailsForm.valid" />
                            <!-- <img src="/assets/stepper-copy.svg" *ngIf=" step == 4 && !nibedonDetailsForm.valid" /> -->
                            <img src="/assets/checkbox-circle-fill.svg" height="19px" width="16px"
                                *ngIf="step == 4 && nibedonDetailsForm.valid" style="cursor: pointer;" />
                            <span class="ms-3" [ngClass]="step == 4 ? 'stepper-text' : 'stepper-text-disable' ">
                                Nibedon Details</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>